import { render, staticRenderFns } from "./MoveableOverlaysControlContainer.vue?vue&type=template&id=7053973e&"
import script from "./MoveableOverlaysControlContainer.vue?vue&type=script&lang=ts&"
export * from "./MoveableOverlaysControlContainer.vue?vue&type=script&lang=ts&"
import style0 from "./MoveableOverlaysControlContainer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports